var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmPowerMainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.5,
    height: 479.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerMainIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 286",
    transform: "translate(36 48)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerMainIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 287",
    fill: "none",
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerMainIcon_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 286",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h50v50H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerMainIcon_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 287",
    fill: "none",
    d: "M0 0h50v50H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 119",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    d: "M50 3.5v474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 120",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    d: "M30.5 2h40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 123",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    d: "M30.5 477.5h40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 131",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M70.5 3h28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 132",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M51.5 53H100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 133",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M73.5 477.5h28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 134",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M51.5 427.5H100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36 72.5)",
    clipPath: "url(#armPowerMainIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 48)",
    clipPath: "url(#armPowerMainIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 313",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 329",
    d: "M50.037 10.76c-13.81 0-25 10.951-25 24.462 0 8.815 3.942 17.763 11.39 21.485h27.221c7.448-3.722 11.39-12.67 11.39-21.485 0-13.51-11.191-24.462-25-24.462m0 39.742A15.761 15.761 0 1165.8 34.741 15.762 15.762 0 0150.037 50.5m0-29.746A13.985 13.985 0 1064.02 34.74a13.985 13.985 0 00-13.983-13.984"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 330",
    d: "M76.68 81.264l14.813-22.621-20.268-13.719 3.574-6 23.889 16.529a3.042 3.042 0 01.771 4.233l-.032.046L79.3 84.675 64.867 89.2a.76.76 0 01-.583-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 331",
    d: "M23.32 81.264L8.507 58.643l20.268-13.719-3.574-6L1.312 55.453a3.042 3.042 0 00-.771 4.233l.032.046L20.7 84.675l14.43 4.53a.76.76 0 00.583-1.4z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPowerIcon",
    transform: "translate(25 46.5)",
    clipPath: "url(#armPowerMainIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPower"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 313",
    fill: "#040000",
    clipPath: "url(#armPowerMainIcon_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 329",
    d: "M25.018 5.38a12.368 12.368 0 00-12.5 12.231c0 4.407 1.971 8.882 5.7 10.743h13.605c3.724-1.861 5.695-6.335 5.695-10.743a12.366 12.366 0 00-12.5-12.231m0 19.871a7.881 7.881 0 117.881-7.881 7.881 7.881 0 01-7.881 7.881m0-14.873a6.992 6.992 0 106.992 6.992 6.992 6.992 0 00-6.992-6.992"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 330",
    d: "M38.34 40.632l7.407-11.311-10.134-6.86 1.787-3 11.944 8.264a1.521 1.521 0 01.386 2.117l-.016.023-10.065 12.473-7.215 2.265a.38.38 0 01-.291-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 331",
    d: "M11.66 40.632l-7.406-11.31 10.134-6.86-1.787-3L.656 27.727a1.521 1.521 0 00-.386 2.117l.016.023 10.066 12.471 7.215 2.265a.38.38 0 00.292-.7z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPowerIcon",
    transform: "translate(25 397.5)",
    clipPath: "url(#armPowerMainIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPower"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 313",
    fill: "#040000",
    clipPath: "url(#armPowerMainIcon_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 329",
    d: "M25.018 5.38a12.368 12.368 0 00-12.5 12.231c0 4.407 1.971 8.882 5.7 10.743h13.605c3.724-1.861 5.695-6.335 5.695-10.743a12.366 12.366 0 00-12.5-12.231m0 19.871a7.881 7.881 0 117.881-7.881 7.881 7.881 0 01-7.881 7.881m0-14.873a6.992 6.992 0 106.992 6.992 6.992 6.992 0 00-6.992-6.992"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 330",
    d: "M38.34 40.632l7.407-11.311-10.134-6.86 1.787-3 11.944 8.264a1.521 1.521 0 01.386 2.117l-.016.023-10.065 12.473-7.215 2.265a.38.38 0 01-.291-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 331",
    d: "M11.66 40.632l-7.406-11.31 10.134-6.86-1.787-3L.656 27.727a1.521 1.521 0 00-.386 2.117l.016.023 10.066 12.471 7.215 2.265a.38.38 0 00.292-.7z"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 135",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M20.5 200v76"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 136",
    fill: "none",
    stroke: "#941894",
    strokeWidth: 3,
    strokeDasharray: "4 2",
    d: "M79.5 200v80"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 4",
    d: "M33.958 244.5v5.315h32.084V244.5l13.458 8.589-13.458 8.588v-5.208H33.958v5.208L20.5 253.088z",
    fill: "#941894"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 5",
    d: "M74.911 41.6h5.315V14.4h-5.315L83.5 3l8.588 11.4H86.88v27.2h5.208L83.499 53z",
    fill: "#941894"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 6",
    d: "M74.911 466.1h5.315v-27.2h-5.315l8.589-11.4 8.588 11.4H86.88v27.2h5.208l-8.589 11.4z",
    fill: "#941894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmPowerMainIcon);
export default __webpack_public_path__ + "static/media/armPowerMainIcon.ca9d2ba6e16e1659.svg";
export { ForwardRef as ReactComponent };